import { useState, useEffect, useCallback, useRef } from "react"
import { useParams } from 'react-router-dom'

import Paper from '@material-ui/core/Paper'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { TabPanel, TabContext, TabList } from '@material-ui/lab';
import { Tab } from '@material-ui/core';

import OutrosDocumentosTableView 	from '@pages/Escola/componentes/OutrosDocumentosTableView'
import QuantitativoCartoesTableView from '@pages/Escola/componentes/QuantitativoCartoesTableView'
import PacotesRecebidosTableView 	from '@pages/Escola/componentes/PacotesRecebidosTableView'
import PendenciaTableView from '@pages/Pendencia/PendenciaTableView'

import Breadcrumbs from '@base/Breadcrumbs'
import Title from '@base/Title'
import Subtitle from '@base/Subtitle'
import Toast from '@base/Toast'

import escolaService from "@services/EscolaService"

const useStyles = makeStyles(
	(theme) => (
		{
			wrapper: {
				padding: theme.spacing(2)
			},
			title: {
				color : "#333",
				fontSize: 24,
			}
		}
	)
);

export const Escola = (props) => {

	const params = useParams();

	const toastRef = useRef(null);

	const [escolaSelecionada, setEscolaSelecionada] 		= useState({});

	const [, setPendencias] 			= useState([]);
	const [tabValue, setTabValue] 		= useState("0");

	const pageName = `${escolaSelecionada.nome}`;
    const breadcrumbs = [{
		path: "/" + params.processo + "/escolas",
		name: 'Escolas'
	}];

	const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

	const carregaInformacoesDaEscola = useCallback((inepInformado) => {
		escolaService.listarPorCodigoInepOuEticket(params.processo, inepInformado).then(resposta => {
			if(resposta.status === 200){
				setEscolaSelecionada(resposta.data);
			}
		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar a Escola!"));


		escolaService.getPendenciasPorEscola(params.processo,inepInformado).then(resposta => {

			setPendencias(resposta.data.map(pendencia => {return {
				id : pendencia.id,
				descricao : pendencia.tipoPendencia.descricao,
				dataCriacao : pendencia.dataCriacao,
				dataResolucao : pendencia.dataResolucao,
				ultimoStatus: pendencia.ultimoStatus
			}}));

		}).catch(error => toastRef.current.show("error", "Ocorreu um problema ao buscar as pendências da escola."));

	},[params.processo]);

	useEffect(() => carregaInformacoesDaEscola(params.escola), [params.escola,carregaInformacoesDaEscola]);

	return (
		<>
			<Toast ref={toastRef} />
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Breadcrumbs links={breadcrumbs} active={pageName} />
				</Grid>
			</Grid><br/>
			<Title>{escolaSelecionada.nome} / {escolaSelecionada.codigoInep}</Title>
			<Subtitle>Visão Geral</Subtitle>
			<br/>

			<Grid item xs={12}>
				<Paper className={useStyles().wrapper} elevation={0}>
				<TabContext value={tabValue}>
					 <TabList onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
					    <Tab label="Informações Gerais" value="0" />
					    <Tab label="Pendências" value="1" />
					    <Tab label="Objetos Postais Recebidos" value="2" />
							<Tab label="Cartões" value="3" />
							<Tab label="Documentos de Envio" value="4" />
					  </TabList>

						<TabPanel value="0">
						
							<Grid alignItems="center" container style={{marginBottom:15}}>
								<Grid item sm={3}>
									<b>Dependência Administrativa </b><br/>{escolaSelecionada.dependenciaAdmin ? escolaSelecionada.dependenciaAdmin : "--"} <br/>
								</Grid>
								<Grid item sm={3}>
									<b>Cidade </b><br/> {escolaSelecionada.municipio ? escolaSelecionada.municipio : "--"}/{escolaSelecionada.uf ? escolaSelecionada.uf : "--"} <br/>
								</Grid>
								<Grid item sm={3}>
									<b>Telefone </b><br/> {escolaSelecionada.telefone ? escolaSelecionada.telefone : "--"} <br/>
								</Grid>
							</Grid>
						
							<Grid alignItems="center" container>
								<Grid item sm={3}>
									<b>Modo Recebimento </b><br/> {escolaSelecionada.modoRecebimento ? escolaSelecionada.modoRecebimento : "--"} <br/>
									
								</Grid>
								<Grid item sm={3}>
								
									<b>Objetos Recebidos </b><br/> {escolaSelecionada.objetosPostais ? escolaSelecionada.objetosPostais.length : "--"} <br/>
								</Grid>
							</Grid>
							
						</TabPanel>

						<TabPanel value="1">
							<Grid alignItems="center" container>
								<Grid item sm={12}>
									<PendenciaTableView
										size={50}
										ocultaNomeEscola
										processo={params.processo}
										filtros={[{"field":"inep","value":params.escola}]} />
								</Grid>
							</Grid>
						</TabPanel>

						<TabPanel value="2">
							<Grid alignItems="center" container>
								<Grid item sm={12}>
									<PacotesRecebidosTableView processo={params.processo} escola={escolaSelecionada} filtros={[]} />
								</Grid>
							</Grid>
						</TabPanel>

						<TabPanel value="3">
							<Grid alignItems="center" container>
								<QuantitativoCartoesTableView processo={params.processo} escola={escolaSelecionada} />
							</Grid>
						</TabPanel>

						<TabPanel value="4">
							<Grid alignItems="center" container>
								<OutrosDocumentosTableView processo={params.processo} escola={escolaSelecionada} />
							</Grid>
						</TabPanel>
					</TabContext>
				</Paper>
			</Grid>
		</>
	);
}

export default Escola;
